import { initBlazeSliders } from '../common/blaze-slider/blaze-slider-loader.js';
import { initContentGalleries } from './gallery/gallery.js';
import { initContentVideos } from './video/video.js';
import { initMediaLibraries } from '../common/media-library/media-library.js';

/** Shared enhancements for explicitly opted-in content pages and previews. */
export function initContentComponents(root = document) {
    initContentGalleries(root);
    initContentVideos(root);
    initMediaLibraries(root);
    initBlazeSliders(root);
}
